import { render, staticRenderFns } from "./PodInfoTab.vue?vue&type=template&id=a23b5fa2&scoped=true&"
import script from "./PodInfoTab.vue?vue&type=script&lang=js&"
export * from "./PodInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./PodInfoTab.vue?vue&type=style&index=0&id=a23b5fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23b5fa2",
  null
  
)

export default component.exports